import React, { forwardRef, useContext, CSSProperties, HTMLAttributes } from 'react';
import classnames from 'classnames';
import VizContext from './VizContext';

export interface Props extends HTMLAttributes<HTMLDivElement> {}

const styleArtboard: CSSProperties = {
  position: 'absolute',
};

/**
 * The VizHTMLArtboard component should be used within the VizHTML component and
 * provides a container that overlays the artboard bounds (within the axis and
 * padded areas).
 */
const VizHTMLArtboard = forwardRef<HTMLDivElement, Props>((props: Props, ref) => {
  const { className, style, ...rest } = props;
  const {
    artboardLeft,
    artboardTop,
    artboardWidth,
    artboardHeight,
  } = useContext(VizContext);

  return (
    <div { ...rest }
        className={ classnames('Bitviz__artboard Bitviz__artboard-html', className) }
        ref={ ref }
        style={ {
          ...styleArtboard,
          ...style,
          height: artboardHeight,
          left: artboardLeft,
          top: artboardTop,
          width: artboardWidth,
        } } />
  );
});

export default VizHTMLArtboard;
